export default "__VITE_ASSET__CXc9lG5G__"